var map = {
	"./images/icon-contrast-component.svg": "c49a",
	"./images/playkids-learning-logo.png": "cebe",
	"./images/playkids-logo-black.png": "f962",
	"./images/playkids-logo-black.svg": "969a",
	"./images/playkids-logo.svg": "2a4c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "216e";